export const APP_NAME = 'Data Bureau Service';
export const NO_DATA_FOUND = 'Data not available';
export const WhiteGlovesTitle = 'Benchmarks and Insights';
export const ROLES = [
  { roleId: 'EngagementAdmin', roleName: 'EngagementAdmin' },
];
export const PARTNER = "Partner";
export const USER = "User";
export const ADMIN = "Admin";
export const OWNER = "Owner";
export const UNITED_KINGDOM = "United Kingdom";
export const AMERICAS = "Americas";
export const EMEIA = "EMEIA";
export const APAC ="APAC";
// Maximum number of ARC engagements a single bulk download (header Download button) accepts.
// Configurable per environment via the REACT_APP_MAX_ARC_DOWNLOAD_SELECTION env var (a CRA
// build-time variable; see .env.example and the per-environment build variable groups). Falls
// back to 25 when the variable is unset or is not a positive integer.
const parsedMaxArcDownloadSelection = Number(
  process.env.REACT_APP_MAX_ARC_DOWNLOAD_SELECTION
);
export const MAX_ARC_DOWNLOAD_SELECTION =
  Number.isInteger(parsedMaxArcDownloadSelection) && parsedMaxArcDownloadSelection > 0
    ? parsedMaxArcDownloadSelection
    : 25;










